import { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import New from "./New";
import Good from "./Good";
import {
  useLocalStorageState,
  useMount,
  useUpdateEffect,
  useScroll,
} from "ahooks";
import dayjs from "dayjs";
import { NavLink } from "../../lib/Navigation";
import Top from "./Top";
import KeepScroll from "../../lib/KeepScroll";

import useUrlState from "@ahooksjs/use-url-state";
import general from "../../general";
import { useHistory } from "react-router-dom";
import _useLocalStorageState from "../../lib/useLocalStorageState";
import urlMatching from "../../utils/urlMatching";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { sessionLocal } from "../util/storage";


// 顶部tab
const router = [
  {
    id: "good",
    title: "首页",
    view: Good,
  },
  {
    id: "new",
    title: "新游",
    view: New,
  },
  {
    id: "top",
    title: "排行榜",
    view: Top,
  },
];

export default (props) => {
  const history = useHistory();
  const [advertising, setAdvertising] = useState(null);

  const [isShow, setIsShow] = useState(
    sessionStorage.getItem("index-advert") || "close"
  );
  useEffect(() => {
    if (!sessionStorage.getItem("index-advert")) {
      if (advertising?.img_url) {
        sessionStorage.setItem("index-advert", "open");
        setIsShow("open");
      }
    }
  }, [advertising]);

  useMount(() => {
    history.listen(() => {
      general.historys.push(window.location.href);
    });
  });

  const [extra, setExtra] = useLocalStorageState(
    "index-tab" + dayjs().format("YYYY-MM-DD"),
    { defaultValue: [] }
  );
  const [current, setCurrent] = useState("good");
  const [query, setQuery] = useUrlState({}, { navigateMode: "replace" });
  useUpdateEffect(() => {
    if (query.tab) {
      setCurrent(query.tab);
    } else {
      setCurrent("good");
    }
  }, [query.tab]);
  const [badge, setBadge] = useLocalStorageState(
    "index-tab-badge-" + dayjs().format("YYYY-MM-DD"),
    { defaultValue: {} }
  );

  const scroll = useScroll();
  const [searchIconShow, setSearchIconShow] = useState(false);
  useEffect(() => {
    if (scroll && scroll.top) {
      setSearchIconShow(true);
    } else {
      setSearchIconShow(false);
    }
  }, [scroll, props.active]);

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/") {
      sessionStorage.removeItem("downParentKid");
      sessionStorage.removeItem("clickGameId");
    }
  }, [location.pathname]);

  const [turnDownData, setTurnDownData] = useState(null);
  const getTurnDownData = () => {
    general.axios
      .post("/v3/base/common/notice")
      .then((res) => {
        console.log("首页被驳回数据-=--", res);

        setTurnDownData(res.data.data);
      })
      .catch((err) => {
        console.log("首页被驳回数据-=--", err);
      });
  };

  useEffect(() => {
    getTurnDownData();
  }, []);

  return (
    <>
      <div className="index-index">
        <div
          className="index-head width"
          style={{
            paddingRight: searchIconShow || current === "new" ? "39px" : "12px",
          }}
        >
          <div className="status-bar-background" />
          <div className="nav">
            <div className="nav-left">
              {router.map((item) => (
                <div
                  key={item.id}
                  className={
                    "item" +
                    (item.id === current ? " active" : "") +
                    (item.id === "new" && !badge[item.id]
                      ? " badge-" + item.id
                      : "")
                  }
                  onClick={() => {
                    setQuery({ tab: item.id });
                    setCurrent(item.id);
                    badge[item.id] = true;
                    setBadge(badge);
                  }}
                >
                  {item.title}
                </div>
              ))}

              {/* 顶部自定义标签*/}
              {extra.length > 0
                ? extra.map((item) => {
                  return (
                    <NavLink
                      key={item.id}
                      className={`item ${item.icon ? "item-img" : ""} ${item.id === current ? " active" : ""
                        }`}
                      user={item.is_verification_login == 1 ? true : false}
                      iframe={
                        item.type == "outer_h5" ? { title: item.name } : null
                      }
                      to={urlMatching(item)}
                      // to='https://activity.bestgame99.com/act2026cj'
                      href={item.type == "outer_contact" ? item.param : ""}
                    >
                      {item.icon ? <img src={item.icon} alt="" /> : item.name}
                      {/* 春节活动 */}
                    </NavLink>
                  );
                })
                : null}
            </div>
          </div>
        </div>

        {/* 首页主体内容 */}
        <div className="index-body">
          {router.map((item) => (
            <KeepScroll
              key={item.id}
              active={props.active && item.id == current}
              lazy
            >
              <div
                className={
                  "index-body-item " + (item.id === current ? "active" : "")
                }
              >
                <item.view
                  active={props.active && item.id === current}
                  setExtra={setExtra}
                  setAdvertising={setAdvertising}
                  isShow={isShow}
                />
              </div>
            </KeepScroll>
          ))}
        </div>
      </div>

      {/* 首页活动弹窗 */}
      {isShow === "open" && advertising?.img_url ? (
        <div className="width index-advertising">
          <div className="adver-main">
            <CloseOutlined
              style={{
                fontSize: "16px",
                color: "#fff",
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 999,
                padding: "9px 16px",
              }}
              onClick={() => {
                setIsShow("close");
                sessionStorage.setItem("index-advert", "close");
              }}
            />

            <NavLink
              className="adver-img"
              user={advertising.if_check == 1 ? true : false}
              iframe={
                advertising.type == "outer_h5"
                  ? { title: advertising.title }
                  : null
              }
              to={urlMatching(advertising)}
              href={
                advertising.type == "outer_contact" ? advertising.param : ""
              }
            >
              <img src={advertising.img_url} alt="" />
            </NavLink>
          </div>
        </div>
      ) : null}

      {!sessionLocal.has("turnDownHave") &&
        turnDownData?.reject?.link_info?.link_route && (
          <div className="width index-turn-down">
            <div className="turn-down-content">
              <img
                className="turn-down-content-img"
                src="/resources/four-three/trade/warn.png"
                alt=""
              />
              <p className="turn-down-content-title">
                {turnDownData?.reject?.content?.title}
              </p>
              <Link
                to={
                  turnDownData?.reject?.link_info?.link_route == "trades_info"
                    ? "/trade/detail?id=" +
                    turnDownData?.reject?.link_info?.link_value
                    : "/rebate/detail?id=" +
                    turnDownData?.reject?.link_info?.link_value
                }
                onClick={() => {
                  sessionLocal.set("turnDownHave", "have");
                }}
              >
                查看详情
              </Link>
            </div>
          </div>
        )}
    </>
  );
};
